import Navbar from "../components/Navbar";
import "./Contatti.css";

export default function Contatti() {
  return (
    <div className="contatti-container">
      <Navbar backButton lightTheme hideLogo />

      <div className="contatti-content">
        <div className="logo-section">
          <img
            src="/assets/logo-wordmark.svg"
            alt="Unitiva Logo"
            width={180}
            height={60}
            className="logo-image"
          />
        </div>

        <div className="info-section">
          <h2 className="info-title">I nostri contatti</h2>

          <div className="contact-info">
            <a
              href="https://www.unitiva.it"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              www.unitiva.it
            </a>
            <a href="mailto:info@unitiva.it" className="contact-link">
              info@unitiva.it
            </a>
          </div>

          <div className="social-icons">
            <a
              href="https://www.instagram.com/unitiva.it?igsh=dTNtaDV1YXo1Zm05"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="white" />
                <path
                  d="M20 13.5C16.4101 13.5 13.5 16.4101 13.5 20C13.5 23.5899 16.4101 26.5 20 26.5C23.5899 26.5 26.5 23.5899 26.5 20C26.5 16.4101 23.5899 13.5 20 13.5ZM20 24.3333C17.6102 24.3333 15.6667 22.3953 15.6667 20C15.6667 17.6047 17.6047 15.6667 20 15.6667C22.3953 15.6667 24.3333 17.6047 24.3333 20C24.3333 22.3953 22.3898 24.3333 20 24.3333ZM28.0833 13.25C28.0833 14.0833 27.4167 14.75 26.5833 14.75C25.75 14.75 25.0833 14.0833 25.0833 13.25C25.0833 12.4167 25.75 11.75 26.5833 11.75C27.4167 11.75 28.0833 12.4167 28.0833 13.25ZM31.9167 14.75C31.8056 12.75 31.3333 10.9722 29.8611 9.5C28.3889 8.02778 26.6111 7.55556 24.6111 7.44444C22.5556 7.33333 17.4444 7.33333 15.3889 7.44444C13.3889 7.55556 11.6667 8.02778 10.1389 9.5C8.66667 10.9722 8.19444 12.75 8.08333 14.75C7.97222 16.8056 7.97222 21.9167 8.08333 23.9722C8.19444 25.9722 8.66667 27.6944 10.1389 29.1667C11.6667 30.6389 13.3889 31.1111 15.3889 31.2222C17.4444 31.3333 22.5556 31.3333 24.6111 31.2222C26.6111 31.1111 28.3889 30.6389 29.8611 29.1667C31.3333 27.6944 31.8056 25.9722 31.9167 23.9722C32.0278 21.9167 32.0278 16.8056 31.9167 14.75ZM29.5278 26.1667C29.0833 27.3333 28.1667 28.25 27 28.6944C25.3333 29.1667 21.7222 29.0278 20 29.0278C18.2778 29.0278 14.6667 29.1667 13 28.6944C11.8333 28.25 10.9167 27.3333 10.4722 26.1667C10 24.5 10.1389 20.8889 10.1389 19.1667C10.1389 17.4444 10 13.8333 10.4722 12.1667C10.9167 11 11.8333 10.0833 13 9.63889C14.6667 9.16667 18.2778 9.30556 20 9.30556C21.7222 9.30556 25.3333 9.16667 27 9.63889C28.1667 10.0833 29.0833 11 29.5278 12.1667C30 13.8333 29.8611 17.4444 29.8611 19.1667C29.8611 20.8889 30 24.5 29.5278 26.1667Z"
                  fill="#4260D1"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/unitivasrls"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="white" />
                <path
                  d="M13.5 11.5C13.5 12.6046 12.6046 13.5 11.5 13.5C10.3954 13.5 9.5 12.6046 9.5 11.5C9.5 10.3954 10.3954 9.5 11.5 9.5C12.6046 9.5 13.5 10.3954 13.5 11.5ZM13.5 15.5H9.5V30.5H13.5V15.5ZM21.5 15.5H17.5V30.5H21.5V22.5C21.5 18.5 26.5 18.5 26.5 22.5V30.5H30.5V20.5C30.5 14.5 23.5 14.5 21.5 17.5V15.5Z"
                  fill="#4260D1"
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/unitiva.it/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="white" />
                <path
                  d="M30.5 20C30.5 14.201 25.799 9.5 20 9.5C14.201 9.5 9.5 14.201 9.5 20C9.5 25.107 13.2091 29.3562 18.0938 30.2578V23.0469H15.5781V20H18.0938V17.6953C18.0938 15.2133 19.6657 13.7656 21.9297 13.7656C23.0078 13.7656 24.1328 13.9531 24.1328 13.9531V16.4062H22.8906C21.6677 16.4062 21.2812 17.1514 21.2812 17.9167V20H24.0156L23.5723 23.0469H21.2812V30.2578C26.1659 29.3562 29.875 25.107 30.5 20Z"
                  fill="#4260D1"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
